import { z } from 'zod';
import { PhoneNumberSchema } from './auth.schemas.js';

export const TenantUserRoleSchema = z.enum(['OWNER_ADMIN', 'GYM_STAFF', 'PLATFORM_ADMIN']);

export const CreateTenantUserInputSchema = z.object({
  email: z.string().email(),
  firstName: z.string().max(100).optional(),
  lastName: z.string().max(100).optional(),
  phone: PhoneNumberSchema.optional(),
  role: TenantUserRoleSchema,
});

export const CreateAdminCustomerInputSchema = CreateTenantUserInputSchema.omit({ role: true });

export const UpdateTenantUserInputSchema = z.object({
  firstName: z.string().max(100).nullable().optional(),
  lastName: z.string().max(100).nullable().optional(),
  phone: PhoneNumberSchema.nullable().optional(),
  role: TenantUserRoleSchema.optional(),
});

export const UpdateAdminCustomerInputSchema = z.object({
  email: z.string().email().optional(),
  firstName: z.string().max(100).nullable().optional(),
  lastName: z.string().max(100).nullable().optional(),
  phone: PhoneNumberSchema.nullable().optional(),
  isActive: z.boolean().optional(),
});

export type CreateTenantUserInput = z.infer<typeof CreateTenantUserInputSchema>;
export type CreateAdminCustomerInput = z.infer<typeof CreateAdminCustomerInputSchema>;
export type UpdateTenantUserInput = z.infer<typeof UpdateTenantUserInputSchema>;
export type UpdateAdminCustomerInput = z.infer<typeof UpdateAdminCustomerInputSchema>;
